import * as React from "react";

export const IconCheck = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
    <path d="M9.5501 17.9996L3.8501 12.2996L5.2751 10.8746L9.5501 15.1496L18.7251 5.97461L20.1501 7.39961L9.5501 17.9996Z" fill="currentColor" />
  </svg>
);
